import { ItemCategoryService, ItemsService, ItemSubCategoryService, SizesService, MasterBrandService, TrimsMappingService, RmRackPositionService } from '@gtpl/shared-services/masters';
import { SaleOrderService } from '@gtpl/shared-services/sale-management';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { StoreConsumptionService } from 'libs/shared-services/procurement/src/lib/store-consumption.service';
import { PoItemsRepository } from '../po-creation/repository/po-items.repository';
import { AssignedStockLog } from './assigned-stock-log.entity';
import { CycleChecker } from './cycle-checker.entity';
import { CycleCheckerAdapter } from './dto/cycle-checker.adapter';
import { MaterialPreperationAdapter } from './dto/materail-preperation-adapter';
import { ProductConversionAdapter } from './dto/product-conversion-adapter';
import { StockAdapter } from './dto/stock.adapter';
import { ProductConversion } from './product-conversion-entity';
import { MaterialPreperationRepository } from './repository/material-preperation-repository';
import { StockController } from './stock.controller';
import { Stock } from './stock.entity';
import { StockService } from './stock.service';
import { InvntoryLogs } from './inventory-logs';


@Module({
  imports: [
    TypeOrmModule.forFeature([Stock, ProductConversion, CycleChecker, AssignedStockLog, MaterialPreperationRepository, PoItemsRepository,InvntoryLogs]),
  ],
  controllers: [StockController],
  providers: [StockService, ApplicationExceptionHandler, StockAdapter, MaterialPreperationAdapter, ItemCategoryService, TrimsMappingService, ItemsService, SizesService, SaleOrderService, ItemSubCategoryService, MasterBrandService, CycleCheckerAdapter, StoreConsumptionService, RmRackPositionService, LogsService,ProductConversionAdapter]
})
export class StockModule { }
